import type {
  QuestionFileModelData,
  SurveyImageAnswerValue,
} from '@coorum-research/shared-common/types'
import type { ComponentProps } from 'react'
import type { SurveyElementForm } from './survey-element-form'
import { ElementCommentArea } from './ElementCommentArea'
import { ElementFileForm } from './ElementFileForm'
import { ElementHeader } from './ElementHeader'
import { ElementValidationMessage } from './ElementValidationMessage'
import { SurveyElementLayout } from './SurveyElementLayout'

type Props = {
  currentForm: SurveyElementForm
  validationError: string | null
  onUploadFiles: ComponentProps<typeof ElementFileForm>['onUploadFiles']
  onUploadingChange: ComponentProps<typeof ElementFileForm>['onUploadingChange']
  onValidationError: ComponentProps<typeof ElementFileForm>['onValidationError']
  onCommentChange?: (comment: string) => void
  isPanelQuestion?: boolean
}

export function SurveyElementFile({
  currentForm,
  validationError,
  onUploadFiles,
  onUploadingChange,
  onValidationError,
  onCommentChange,
  isPanelQuestion = false,
}: Props) {
  const currentElement = currentForm.elementJson as QuestionFileModelData

  const handleOnValueChange = (value: SurveyImageAnswerValue[]) => {
    currentForm.setElementResultRecordValue(value)
  }

  const handleCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const comment = e.target.value || ''
    currentForm.setElementResultRecordComment(comment)
    onCommentChange?.(comment)
  }

  return (
    <SurveyElementLayout isPanelQuestion={isPanelQuestion}>
      <ElementValidationMessage
        validationError={validationError}
      />
      <ElementHeader
        currentElement={currentElement}
      />
      <ElementFileForm
        elementJson={currentElement}
        defaultValue={currentForm.getValue() as SurveyImageAnswerValue[]}
        onUploadFiles={onUploadFiles}
        onUploadingChange={onUploadingChange}
        onValidationError={onValidationError}
        onValueChange={handleOnValueChange}
        currentForm={currentForm}
      />
      {currentElement.showCommentArea && (
        <ElementCommentArea
          label={currentElement.commentText}
          placeholder={currentElement.commentPlaceholder}
          defaultValue={currentForm.getComment()}
          onChange={handleCommentChange}
        />
      )}
    </SurveyElementLayout>
  )
}
